import script from "./ViewAllSupervisorGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllSupervisorGroups.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllSupervisorGroups.vue?vue&type=style&index=0&id=7863a4a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7863a4a0"]])

export default __exports__